import { ReactNode, useState } from "react";
import LeftPane from "./LeftPane";
import { useSwipeable } from "react-swipeable";

interface ChildrenProps {
  children?: ReactNode;
}

function AppLayout({ children }: ChildrenProps) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setSidebarOpen(false),
    onSwipedRight: () => setSidebarOpen(true),
    trackTouch: true,
    trackMouse: true,
  });
  return (
    <div
      {...swipeHandlers}
      className="w-full h-[100vh] grid grid-cols-10 relative"
    >
      <aside className="md:block h-full col-span-2 bg-white md:border-r-[1px] md:border-r-pr-primaryLighter overflow-hidden">
        <LeftPane
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      </aside>

      <main className="col-span-10 md:col-span-8 h-[100vh] overflow-y-auto md:px-[2.5rem] py-[3rem] bg-white">
        {children}
      </main>
    </div>
  );
}

export default AppLayout;
